import React, { useEffect } from 'react'
import { selectDescriptions } from '../../utils/utils'

export default function StepTitle({
  // name,
  step,
  attributes,
  // customNote = false,
  // additionalNote
}) {
  const {
    metaTitle = 'Custom Cushion Designer - Design your own Cushions',
    metaDescription = '',
    // htmlTitle,
    // htmlDescription,
  } = selectDescriptions(attributes, step)
  // const hasSubtitle = htmlTitle?.length > 1

  useEffect(() => {
    setMeta()
  }, [])

  const setMeta = () => {
    document.title = metaTitle
    let metaDescriptionElement = document.querySelector('meta[name="description"]')

    if (!metaDescriptionElement) {
      metaDescriptionElement = document.createElement('meta')
      metaDescriptionElement.setAttribute('name', 'description')
      document.querySelector('head').appendChild(metaDescriptionElement)
    }

    metaDescriptionElement.setAttribute('content', metaDescription)
  }

  return (
    <>
      {/* TO DO - we should see what we can do with this */}
      {/* <h1
        className={`cushion-name ${customNote ? 'custom' : ''} ${hasSubtitle ? 'with-subtitle' : ''}`}
      >
        {' '}
        {htmlTitle?.[0] || name}{' '}
      </h1>
      {hasSubtitle ? <h2 className="cushion-subname">{htmlTitle?.[1]}</h2> : null} */}
      {/* {htmlDescription || additionalNote ? (
        <div className="note-background">
          <div className={`note ${htmlDescription && additionalNote ? 'first-note' : ''}`}>
            {htmlDescription}
          </div>
          <div className="note">{additionalNote}</div>
        </div>
      ) : null} */}
    </>
  )
}
